// extracted by mini-css-extract-plugin
export var buttons = "ExitPopup-module--buttons--6cb4e";
export var modal = "ExitPopup-module--modal--e3910";
export var modalContent = "ExitPopup-module--modalContent--48d9a";